import { render } from "./IntroHeader.vue?vue&type=template&id=4f9c60dd&scoped=true"
import script from "./IntroHeader.vue?vue&type=script&lang=js"
export * from "./IntroHeader.vue?vue&type=script&lang=js"

import "./IntroHeader.vue?vue&type=style&index=0&id=4f9c60dd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f9c60dd"]])

export default __exports__